import { Component, OnInit, OnDestroy } from '@angular/core';
import { CampanhaPerfil } from '../../core/interface/campanha';
import { Router } from '@angular/router';
import { EnumStatus } from '../../core/enum/EnumStatus';
import { PerfilInvestidor } from '../../core/interface/perfil-investidor';
import { CreatedPerfilParticipante, ParticipanteConfirmTerm, PerfilParticipante } from '../../core/interface/perfil-participante';
import { AppStateService } from '../../shared/services/app-state.service';
import { HttpClientService } from '../../shared/services/http-client.service';
import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PerfilRecomendado } from '../../core/interface/perfil-recomendado';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { SummaryCardComponent } from '../../shared/components/summary-card/summary-card.component';
import { Protocolo } from '../../core/interface/protocolo';
import { EnumStatusResponse } from '../../core/enum/EnumHttpResponse';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { FormsModule } from '@angular/forms';
import { CheckboxComponent } from '../../shared/components/checkbox/checkbox.component';
import { QuestionarioRespondido } from '../../core/interface/questionario';
import { LoaderService } from '../../shared/services/loader.service';
import { ToastService } from '../../shared/services/toast.service';
import { finalize } from 'rxjs';

// Espera até o pdf.js reprocessar o container depois que a tela cheia fecha,
// para pedir ao pai uma medição já com o layout estabilizado.
const DELAY_REMEDICAO_FULLSCREEN = 400;

// `resize` é tipado como string na d.ts do iframe-resizer, mas valida number em
// tempo de execução; o cast mantém a chamada dentro do que a lib aceita.
function forcarAlturaDoIframe(
  parentIFrame: NonNullable<typeof window.parentIFrame>,
  altura: number,
): void {
  (parentIFrame.resize as unknown as (customHeight: number) => void)(Math.round(altura));
}


@Component({
  selector: 'app-term',
  imports: [CommonModule, ModalComponent, PdfViewerModule, FormsModule, SummaryCardComponent, CheckboxComponent],
  templateUrl: './term.component.html',
  styleUrl: './term.component.scss',
})
export class TermComponent implements OnInit, OnDestroy {
  exibirModal: boolean = false;
  modalCancelamento: boolean = false;
  protocolo?: Protocolo;
  agreeTerm = false;
  token?: string = '';

  pdfSrc?: string;
  pdfObjectUrl?: string;
  safePdfSrc?: SafeResourceUrl;
  pdfZoom: number = 1;
  isFullscreen: boolean = false;
  // Evita cliques repetidos no botão "Assinar termo" durante a requisição.
  isSigning = false;
  // Encerra o acompanhamento da janela do pai enquanto a tela cheia está aberta.
  private pararDeAcompanharPai?: () => void;

  perfil: string = '';
  dataVigencia: string = '';
  dateNow = new Date();

  EnumStatus = EnumStatus;
  campanha?: CampanhaPerfil;
  perfilParticipante?: PerfilParticipante;
  perfisInvestidor?: PerfilInvestidor[];
  perfilSelecionado?: number | undefined;
  perfilSelecionadoDescricao?: string;
  perfilRecomendado?: PerfilRecomendado;

  participanteConfirmTerm?: ParticipanteConfirmTerm;
  refazerPerfil?: CreatedPerfilParticipante;

  constructor(
    private router: Router,
    private httpClientService: HttpClientService,
    private appStateService: AppStateService,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastService: ToastService
  ) { 





  }

  ngOnInit(): void {
    const token = this.appStateService.getToken();

    if (!token) {
      console.warn('Home carregado sem estado completo:', { token });
      this.router.navigate(['/not-found']);
      return;
    }
    this.token = token;
    this.postData();
    this.getTermoResponsabilidade(this.token);
  }

  ngOnDestroy(): void {
    // Sair da tela com a tela cheia aberta deixaria o iframe preso na altura da
    // janela, com o autoResize desligado.
    if (this.isFullscreen) {
      this.liberarJanelaDoPai();
    }

    if (this.pdfObjectUrl) {
      URL.revokeObjectURL(this.pdfObjectUrl);
    }
  }

  postData() {
    this.campanha = this.appStateService.getCampanha();
    this.perfilParticipante = this.appStateService.getPerfilParticipante();
    this.perfilSelecionado = this.appStateService.getSelectedProfile();
    this.perfisInvestidor = this.appStateService.getPerfisInvestimento();
    this.perfilRecomendado = this.appStateService.getPerfilRecomendado();
    // Se houver perfil selecionado, resolve o nome pela lista de perfis;
    // caso contrário, usa o perfil selecionado já persistido no participante.
    this.perfilSelecionadoDescricao = this.perfilSelecionado
      ? this.perfisInvestidor?.find(
          perfil => perfil.idPerfilInvestimento === this.perfilSelecionado
        )?.nomePerfilInvestimento
      : this.perfilParticipante?.perfilSelecionado;

    this.protocolo = this.appStateService.getProtocolo();
  }

  formatarData(data?: string) {
    if (!data) return "";

    const partes = data.split("-");
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }

  goBack() {
    this.router.navigate(['/profile-selection']);
  }

  // modal de confirmação de solicitação

  inicio() {
    //direcionar para a tela inicial do portal restrito da vivest
  }

  confirm(): void {
    //faz a integração com o endpoint de confirmação se o retorno for positivo abre o modal de sucesso com o protocolo
    if(this.perfilParticipante?.id && this.perfilSelecionado && this.token) {
      this.participanteConfirmTerm = {
        idPerfilSelPart: this.perfilSelecionado,
        idPerfInvestPartic: this.perfilParticipante.id
      };
      this.postPerfilInvestidor(this.token, this.perfilParticipante?.id, this.participanteConfirmTerm);
    }
  }

  viewTerm() {
    this.exibirModal = false;
  }

  viewForm() {
    if (this.token && this.perfilParticipante?.id)
      this.getQuestionnaireHistory(this.token, this.perfilParticipante?.id)

    //his.postData();
  }

  // ações modal de cancelamento

  openModalCancel() {
    this.modalCancelamento = true;
  }

  closeModalCancel() {
    this.modalCancelamento = false;
  }

  confirmCancel() {
    // Preserve token, clear other state and navigate to home
    const token = this.appStateService.getToken();

    if (this.perfilParticipante?.numMatrPartf && this.perfilParticipante?.idCampanha && this.perfilParticipante?.idPerfilAtual && this.perfilParticipante.idPerfilSelecionado && token) {

      this.refazerPerfil = {
        numMatrPartf: this.perfilParticipante.numMatrPartf,
        idCampanha: this.perfilParticipante.idCampanha,
        idPerfilAnt: this.perfilParticipante.idPerfilAtual,
        idPerfilAtingido: this.perfilParticipante.idPerfilRecomendado,
        idPerfilSelPart: this.perfilParticipante.idPerfilSelecionado
      }

      this.postPerfilParticipanteRefazer(token, this.refazerPerfil);
    }
  }

  // Controles PDF

  zoomIn(): void {
    if (this.pdfZoom < 3) {
      this.pdfZoom += 0.2;
    }
  }

  zoomOut(): void {
    if (this.pdfZoom > 0.5) {
      this.pdfZoom -= 0.2;
    }
  }


  // Tela cheia via CSS (classe .fullscreen no container). Não usa a Fullscreen
  // API porque, dentro de um iframe sem allow="fullscreen", ela seria bloqueada.
  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;

    if (this.isFullscreen) {
      this.ocuparJanelaDoPai();
    } else {
      this.liberarJanelaDoPai();
    }
  }

  /**
   * Enquanto a tela cheia está aberta, o iframe passa a ter exatamente a altura
   * da janela que o hospeda, e o pai é rolado até o topo dele.
   *
   * Sem isso `100vh` não cobre a janela: o iframe é dimensionado pela altura do
   * conteúdo, então lá dentro `100vh` vale essa altura, e não a da janela.
   */
  private ocuparJanelaDoPai(): void {
    const parentIFrame = window.parentIFrame;

    // Fora do iframe-resizer (app aberto direto), `100vh` já é a janela real.
    if (!parentIFrame?.getParentProps) {
      return;
    }

    let primeiraMedida = true;

    // O callback é rechamado quando o pai rola ou muda de tamanho, então a
    // altura forçada acompanha o redimensionamento da janela. A rolagem é feita
    // só na primeira vez, para não brigar com o scroll do participante.
    this.pararDeAcompanharPai = parentIFrame.getParentProps(({ viewport }) => {
      parentIFrame.autoResize(false);
      forcarAlturaDoIframe(parentIFrame, viewport.height);

      if (primeiraMedida) {
        primeiraMedida = false;
        parentIFrame.scrollToOffset(0, 0);
      }
    });
  }

  private liberarJanelaDoPai(): void {
    this.pararDeAcompanharPai?.();
    this.pararDeAcompanharPai = undefined;

    // Devolve a altura do iframe ao conteúdo.
    window.parentIFrame?.autoResize(true);

    this.pedirNovaMedicaoAoPai();
  }

  /**
   * Pede à página que hospeda o iframe uma nova medição da altura.
   *
   * Duas vezes de propósito: o Angular tira a tela cheia no frame seguinte e o
   * pdf.js reprocessa o container algum tempo depois — sem a segunda chamada, a
   * medição sairia com o layout ainda em transição e o iframe ficaria na altura
   * da tela cheia.
   */
  private pedirNovaMedicaoAoPai(): void {
    const remedir = () => window.parentIFrame?.resize?.();

    requestAnimationFrame(remedir);
    setTimeout(remedir, DELAY_REMEDICAO_FULLSCREEN);
  }

  /**
   * Baixa o termo já carregado, reaproveitando o object URL do blob — não faz
   * uma segunda requisição ao endpoint.
   */
  downloadTerm(): void {
    if (!this.pdfObjectUrl) {
      this.toastService.show('O termo ainda está sendo carregado. Aguarde e tente novamente.', 'error');
      return;
    }

    const link = document.createElement('a');
    link.href = this.pdfObjectUrl;
    link.download = this.nomeArquivoTermo;
    link.rel = 'noopener';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * Nome do arquivo baixado. Inclui o protocolo quando existe, para que o
   * participante identifique a via sem precisar abrir o PDF.
   */
  get nomeArquivoTermo(): string {
    const protocolo = this.perfilParticipante?.numProtocoloSolicitacao?.trim();

    if (!protocolo) {
      return 'termo-de-adesao.pdf';
    }

    // Remove o que não é seguro em nome de arquivo (barras, dois-pontos etc.).
    const protocoloSeguro = protocolo.replace(/[^\w-]+/g, '-');

    return `termo-de-adesao-${protocoloSeguro}.pdf`;
  }

  /**
   * Nome do perfil selecionado (conversão do ID → nome na apresentação).
   * O ID permanece armazenado no AppState; aqui apenas resolvemos o nome via
   * `perfilSelecionadoDescricao`. Retorna '-' quando o perfil não é encontrado.
   */
  get nomePerfilSelecionado(): string {
    return this.perfilSelecionadoDescricao ?? '';
  }

  get solicitacaoAndamento(): boolean {

    this.postData();
    if (this.perfilParticipante) {
      return this.perfilParticipante.status === EnumStatus.Solicitado ? true : false;
    }

    return false;
  }

  private getTermoResponsabilidade(token: string): void {
    this.loaderService.showLoader();
    this.httpClientService
      .getTermoResponsabilidade(token)
      .then((blob: Blob) => {
        // O endpoint retorna o arquivo diretamente (responseType: 'blob'),
        // portanto `blob` já é o conteúdo do PDF (não é um HttpResponse).
        if (this.pdfObjectUrl) {
          URL.revokeObjectURL(this.pdfObjectUrl);
        }

        this.pdfObjectUrl = URL.createObjectURL(blob);

        this.pdfSrc = this.pdfObjectUrl;

        this.safePdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.pdfObjectUrl
        );
      })
      .catch(error => {
        console.error(
          'Erro buscar termo de responsabilidade:',
          error
        );
        this.toastService.show('Não foi possível buscar o termo de responsabilidade.', 'error');
      })
      .finally(() => this.loaderService.hideLoader());
  }

  private postPerfilInvestidor(token: string, idParticipante: number, participante: ParticipanteConfirmTerm): void {
    this.isSigning = true;
    this.loaderService.showLoader();
    this.httpClientService.postPerfilInvestidor(token, idParticipante, participante)
      .then(response => {

        // Só encadeia a atualização do participante se o 1º POST retornar 200 (OK).
        if (response.status === EnumStatusResponse.Success) {
          this.getPerfilParticipante(token);
        }
      })
      .catch(error => {
        console.error('Erro ao salvar solicitação de confirmação de troca de perfil:', error);
        this.toastService.show('Não foi possível enviar a solicitação de confirmação de troca de perfil. Tente novamente.', 'error');
      })
      .finally(() => {
        this.loaderService.hideLoader();
      });
  }


  private getPerfilParticipante(token: string): void {
    this.loaderService.showLoader();
    this.httpClientService.getPerfilParticipante(token)
    .then(response => {
        if (response.status === EnumStatusResponse.Success) {
          const body = response.body;
          let participante: PerfilParticipante | undefined;
          if (Array.isArray(body)) {
            participante = body[0] as PerfilParticipante;
          } else {
            participante = body as PerfilParticipante;
          }

          if (participante) {
            this.perfilParticipante = participante;
            this.appStateService.setPerfilParticipante(this.perfilParticipante);
            this.appStateService.setSolicitacaoAndamento(this.perfilParticipante.status === EnumStatus.Iniciado);

            // Sucesso do fluxo completo: exibido somente após os dois POSTs concluírem.
            this.toastService.show('Solicitação de confirmação enviada com sucesso.', 'success');
          }
        }
      })
      .catch(error => {
        console.error('Participante não encontrado para os parâmetros fornecidos.', error);
        this.toastService.show(error?.message ?? 'Não foi possível carregar os dados do participante.', 'error');
        this.router.navigate(['/not-found']);
      })
      .finally(() => this.loaderService.hideLoader());
  }


  private getQuestionnaireHistory(token: string, idParticipante: number): void {
    this.loaderService.showLoader();
    this.httpClientService.getQuestionnaireHistory(token, idParticipante)
      .then(response => {

        if (response.status === EnumStatusResponse.Success) {
          const body: QuestionarioRespondido[] = response.body as QuestionarioRespondido[];

          this.appStateService.setEscolhaParticipante(body);

          this.router.navigate(['/history']);
        }
      })
      .catch(error => {
        console.error('Erro ao consultar o Questionnaire History', error);
        this.toastService.show('Não foi possível carregar o questionário preenchido.', 'error');
      })
      .finally(() => this.loaderService.hideLoader());
  }

  private postPerfilParticipanteRefazer(token: string, participante: CreatedPerfilParticipante): void {
    this.loaderService.showLoader();
    this.httpClientService.postPerfilParticipanteRefazer(token, participante)
      .then(response => {

        if (response.status === EnumStatusResponse.Created) {
          this.router.navigate(['/']);
        }
      })
      .catch(error => {
        console.error('Erro ao refazer perfil de investidor', error);
        this.toastService.show('Não foi possivel refazer o perfil de investidor.', 'error');
      })
      .finally(() => this.loaderService.hideLoader());
  }

}
